import {
  useFeatureFlags,
  useFeatureFlagsProviderContext,
} from '@brightdrop/feature-flags-client';

import { FEEDBACK_LOOP_FLAG } from '~/common/models/featureFlags.model';

/**
 * Whether the in-app feedback entry points and API should be active.
 */
export const useFeedbackLoopEnabled = (): boolean => {
  const { ready: areFeatureFlagsReady } = useFeatureFlagsProviderContext();
  const { getFlag } = useFeatureFlags();
  return areFeatureFlagsReady && Boolean(getFlag(FEEDBACK_LOOP_FLAG));
};
